import { readAuthDesignDecision } from '@shared/utils/authDesignDecision';
import {
  isLoginOtpVerificationScreen,
  isSignupOtpVerificationScreen,
} from './flowContract';

export const isReturningUserOtpScreen = (screenName?: string): boolean =>
  isLoginOtpVerificationScreen(screenName) && readAuthDesignDecision();

export const shouldUseNewOtpVerificationScreen = (
  newDesignEnabled: boolean,
  screenName?: string
): boolean =>
  (isSignupOtpVerificationScreen(screenName) && newDesignEnabled === true) ||
  isReturningUserOtpScreen(screenName);
